import React, { Component } from 'react';
import { LineOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom'
import { Form, Input, Button, Checkbox } from 'antd';
import 'antd/dist/antd.css';
import Slider from "react-slick";
import { insertNewUserToServer } from '../../../networking/Server'
import service_24_7 from './images/service_24_7.png';
import Camera_Clound from './images/Camera_Clound.png';
import Canh_bao_qua_sms from './images/Canh_bao_qua_sms.png';
import Ho_tro_mo_rong from './images/Ho_tro_mo_rong.png';
import Ma_hoa from './images/Ma_hoa.png';
import Mo_hinh_he_thong_1 from './images/Mo_hinh_he_thong_1.png';
import Nhan_dang_khuon_mat from './images/Nhan_dang_khuon_mat.png';
import An_toan_bao_mat from './images/An_toan_bao_mat.png';
import Quan_ly_tap_trung from './images/Quan_ly_tap_trung.png';
import Streaming from './images/Streaming.png';
import phat_hien_xam_nhap from './images/phat_hien_xam_nhap.png';
import truy_cap_thep_IP from './images/truy_cap_thep_IP.png';
import Lien_he from './images/Lien_he.png';

class BeexCameraPlatform extends Component {
  formRef = React.createRef();
  render() {
    const isMobile = /^(\+84|84|0|1){1}([0-9]{7,10})\b$/i
    const layout = {
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
    };
    const tailLayout = {
      wrapperCol: {
        offset: 4,
        span: 16,
      },
    };
    const onFinish = values => {
      insertNewUserToServer(values).then((item) => {
        // this.setState({
        //   itemOrder: orderFromServer
        // });
        this.formRef.current.resetFields();
        console.log('Success:', item);
      }).catch((error) => {
        console.error(error);
      });
    };

    const onFinishFailed = errorInfo => {
      console.log('Failed:', errorInfo);
    };
    var settings = {
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true
    };
    return (
      <>
        <section className="bread-crumb">
          <span className="crumb-border" />
          <div className="container">
            <div className="rows">
              <div className="col-xs-12 a-left" style={{ paddingTop: '25px' }}>
                <span>Beex Camera Platform</span>
              </div>
              <div className="b-left">
                <span>Cloud Camera</span>
              </div>
            </div>
          </div>
        </section>
        <section className="awe-section-2" id="section_1">
          <div className="section_about lazyload" id="section_service_tab_camera_1">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-xl-5">
                  <div className="department-carousel2">
                    <div className="department-item">
                      <div className="h-sub"><LineOutlined style={{ fontSize: '24px' }} /> CAMERA CLOUD</div>
                      <h2 className="title" style={{ fontFamily: 'fujiyama' }}>Cloud Camera và chức năng quản lý của sản phẩm</h2>
                      <div>
                        <strong style={{ color: '#000000' }}>Cloud Camera:</strong>
                      </div>
                      <br />
                      <div style={{ textAlign: 'justify', color: '#000000' }} id={'Check_Slide_1'}>
                        Cloud Camera là dịch vụ giám sát, quản lý và lưu trữ tập trung dữ liệu Camera của doanh nghiệp
                        trên hạ tầng công nghệ Điện toán đám mây, cho phép quản trị thông minh và an toàn tuyệt đối hàng
                        ngàn camera mọi lúc mọi nơi. Thiết bị sử dụng đường truyền Internet và hỗ trợ đa nền tảng Web,
                        App để truy cập hệ thống. Ngoài ra Camera sử dụng trí tuệ nhân tạo (AI) có tính năng phân tích
                        nâng cao thực hiện các hành vi thông minh, thích ứng với nhiều tính huống.
                        </div>
                      <div style={{ textAlign: 'justify', color: '#000000' }} id={'Check_Slide_2'}>
                        Cloud Camera là dịch vụ giám sát, quản lý và lưu trữ tập trung dữ liệu Camera của doanh nghiệp
                        trên hạ tầng công nghệ Điện toán đám mây, cho phép quản trị thông minh và an toàn tuyệt đối hàng
                        chục nghìn camera mọi lúc mọi nơi. Cloud Camera ứng dụng trí tuệ nhân tạo (AI) trong việc xử lý
                        ảnh nhận dạng và phân tích nâng cao cho mục đích khai thác dữ liệu của doanh nghiệp.
                        </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-7 col-xl-7">
                  <img className="img_beex_camera_1" src={Camera_Clound} alt="Về chúng tôi" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="awe-section-3" id="section_2">
          <div className="section_service_tab clearfix" style={{ background: '#FFFFFF' }} id="section_service_tab_camera_5">
            <div className="container">
              <h3 className="c-center text-center">ƯU ĐIỂM CỦA SẢN PHẨM</h3>
              <div className="title-wrap text-center">
                <h2 className="h1 double-title" style={{ fontFamily: 'fujiyama' }} id="section_service_tab_camera_2">
                  <span>Quản lý tập trung, khả năng streaming ổn định và an toàn</span>
                </h2>
              </div>
              <div className="nav nav-pills-icons" role="tablist">
                <div >
                  <div className="div_beex_camera"><img style={{ width: '87px', height: '55px', margin: "25px 38px 17px" }} src={Quan_ly_tap_trung} alt="Về chúng tôi" />
                    <div>
                      <div><strong style={{ color: '#0E9347', marginLeft: '-10px' }}>Khả năng quản lý tập trung</strong></div>
                      <div style={{ margin: '0px 10px' }}>Cung cấp khả năng quản lý tập trung camera ở các khu vực địa lý khác nhau thông qua giao diện tương tác
                      duy nhất (web, applications)</div>
                    </div>
                  </div>
                </div>
                <div >
                  <div className="div_beex_camera"><img style={{ width: '130px', height: '55px', margin: "25px 38px 16px" }} src={Streaming} alt="Về chúng tôi" />
                    <div >
                      <div><strong style={{ color: '#0E9347' }}>Khả năng streaming camera ổn định độ trễ thấp</strong></div>
                      <div style={{ margin: '0px 10px' }}>Quá trình xử lý truyền dữ liệu từ camera đến thiết bị cuối rất phức tạp, đòi hỏi áp dụng nhiều công nghệ.
                      Đội ngũ Beex đã khắc phục vấn đề này để mang lại giải pháp giúp streaming dữ liệu độ trễ thấp, an toàn và tiết kiệm băng thông mạng.</div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="div_beex_camera"><img style={{ width: '71px', height: '80px', margin: "9px 38px 15px" }} src={An_toan_bao_mat} alt="Về chúng tôi" />
                    <div >
                      <div><strong style={{ color: '#0E9347' }}>An toàn và bảo mật</strong></div>
                      <div style={{ margin: '0px 10px' }}>Toàn bộ dữ liệu kênh truyền được mã hoá, giao tiếp sử dụng giao thức riêng tự phát triển, dữ liệu
                      lưu trữ được mã hoá 3 lớp, quản lý truy cập. Bằng những công cụ này BeeX Cloud Camera giúp đảm bảo dữ liệu khách hàng luôn được an toàn</div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="div_beex_camera"><img style={{ width: '64px', height: '64px', margin: "24px 38px 16px" }} src={Ho_tro_mo_rong} alt="Về chúng tôi" />
                    <div >
                      <div><strong style={{ color: '#0E9347' }}>Hỗ trợ mở rộng</strong></div>
                      <div style={{ margin: '0px 10px' }}>Đội ngũ đã phát triển Camera Clound có thể dễ dàng thêm ứng dụng phân tích ảnh nâng cao. Linh hoạt liên
                      kết với các hệ thống cảnh báo thông báo trình trạng kết nối qua SMS và auto-voice. Khả năng mở rộng quy mô quản lý không giới hạn.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="awe-section-3" style={{ background: 'rgba(14, 147, 71, 0.1)' }} id="section_3">
          <div className="section_service_tab1 clearfix">
            <div className="container">
              <h3 className="c-center text-center">MÔ HÌNH HỆ THỐNG</h3>
              <div className="title-wrap">
                <h2 className="h1 double-title" style={{ fontFamily: 'fujiyama' }} id="section_service_tab_camera_4">
                  <span>Linh hoạt trong khả năng kết nối và đồng bộ với các hệ thống khác</span>
                </h2>
              </div>
              <div className="title-wrap">
                <div className="double-title">
                  <img className="lazyload imageload img-fluid loaded" id="section_service_tab_camera_3" src={Mo_hinh_he_thong_1} alt="cmc datacenter" data-was-processed="true" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="awe-section-3" id="section_4">
          <div className="section_service_tab2 clearfix">
            <div className="container">
              <h3 className="c-center text-center">CÁC DỊCH VỤ VÀ ỨNG DUNG ADD-ON</h3>
              <div className="title-wrap">
                <div className="h1 double-title" style={{ fontFamily: 'fujiyama' }}>
                  <span>Mở rộng quy mô quản lý không giới hạn</span>
                </div>
              </div>
            </div>
          </div>
          <div className="container_mobile">
            <style>{cssstyle}</style>
            <Slider {...settings}>
              <div>
                <div className="div4">
                  <div style={{ textAlign: 'center', margin: '0px 24px' }}>
                    <img style={{ width: '85px', height: '85px', margin: "26px 0px 20px", display: 'initial' }} src={Ma_hoa} alt="Về chúng tôi" />
                    <div>
                      <div style={{ margin: '0px 22px', color: '#16181D', fontSize: '20px' }}>Dịch vụ mã hoá dữ liệu lưu trữ</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="div4">
                  <div style={{ textAlign: 'center', margin: '0px 24px' }}>
                    <img style={{ width: '87px', height: '87px', margin: "26px 0px 17px", display: 'initial' }} src={Canh_bao_qua_sms} alt="Về chúng tôi" />
                    <div>
                      <div style={{ margin: '0px 22px', color: '#16181D', fontSize: '20px' }}>Dịch vụ cảnh báo qua SMS, Auto-Call</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="div4">
                  <div style={{ textAlign: 'center', margin: '0px 24px' }}>
                    <img style={{ width: '72px', height: '84px', margin: "26px 0px 20px", display: 'initial' }} src={Nhan_dang_khuon_mat} alt="Về chúng tôi" />
                    <div>
                      <div style={{ margin: '0px 22px', color: '#16181D', fontSize: '20px' }}>Dịch vụ nhận dạng khuôn mặt</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="div4">
                  <div style={{ textAlign: 'center', margin: '0px 24px' }}>
                    <img style={{ width: '93px', height: '89px', margin: "21px 0px 19px", display: 'initial' }} src={phat_hien_xam_nhap} alt="Về chúng tôi" />
                    <div>
                      <div style={{ margin: '0px 22px', color: '#16181D', fontSize: '20px' }}>Dịch vụ phát hiện xâm nhập</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="div4">
                  <div style={{ textAlign: 'center', margin: '0px 24px' }}>
                    <img style={{ width: '130px', height: '55px', margin: "45px 0px 27px", display: 'initial' }} src={Streaming} alt="Về chúng tôi" />
                    <div>
                      <div style={{ margin: '0px 22px', color: '#16181D', fontSize: '20px' }}>Dịch vụ streaming nâng cao</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="div4">
                  <div style={{ textAlign: 'center', margin: '0px 24px' }}>
                    <img style={{ width: '73px', height: '90px', margin: "26px 0px 15px", display: 'initial' }} src={truy_cap_thep_IP} alt="Về chúng tôi" />
                    <div>
                      <div style={{ margin: '0px 22px', color: '#16181D', fontSize: '20px' }}>Dịch vụ quản lý truy cập theo IP</div>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
          <section className="awe-section-3" style={{ background: '#0E9347' }}>
            <div className="clearfix">
              <div className="container" style={{ color: '#FFFFFF' }}>
                <br />
                <span className="section_service_tab3">
                  <span style={{ fontSize: '17px' }}>CHI PHÍ VÀ TRIỂN KHAI</span>
                </span>
                <br />
                <span className="section_service_tab4" id="section_service_tab_camera_6">
                  <span>Liên hệ với chúng tôi 0332796542</span>
                </span>
                <span className="section_service_tab6">
                  <img className='img_beex_camera_3' src={service_24_7} alt="Về chúng tôi" />
                </span>
              </div>
            </div>
          </section>
          <section className="awe-section-3">
            <br />
            <br />
          </section>
        </section>
        <section className="awe-section-2" id="section_5">
          <div className="section_about1 lazyload">
            <div className="container">
              <div className="row">
                <div className="col-md-7 col-xl-7">
                  <img className='img_ho_tro' src={Lien_he} alt="Về chúng tôi" />
                </div>
                <div className="col-md-5 col-xl-5">
                  <div className="department-carousel2">
                    <div className="department-item">
                      <div className="h-sub text-center" id='text_ho_tro'>BẠN CẦN CHÚNG TÔI HỖ TRỢ</div>
                      <Form
                        {...layout}
                        name="basic"
                        ref={this.formRef}
                        initialValues={{
                          remember: false,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                      >
                        <Form.Item
                          name="Họ tên"
                          rules={[
                            {
                              required: true,
                              message: 'Vui lòng nhập thông tin',
                            },
                          ]}
                        >
                          <Input id="input_contact_1" placeholder="Họ tên liên lạc" />
                        </Form.Item>
                        <Form.Item
                          name="Số điện thoại"
                          rules={[
                            {
                              required: true,
                              message: 'Vui lòng nhập thông tin',
                            },
                            {
                              pattern: isMobile,
                              message: 'Vui lòng nhập đúng định dạng sđt',
                            },
                          ]}
                        >
                          <Input id='input_contact_1' placeholder="Số điện thoại" />
                        </Form.Item>
                        <Form.Item
                          name="Email"
                          rules={[
                            {
                              required: true,
                              message: 'Vui lòng nhập thông tin',
                            },
                            {
                              type: 'email',
                              message: 'Vui lòng nhập đúng định dạng email',
                            }
                          ]}
                        >
                          <Input id='input_contact_1' placeholder="Email" />
                        </Form.Item>
                        <Form.Item
                          name="Ý kiến hỗ trợ"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: 'Vui lòng nhập thông tin',
                        //   },
                        // ]}
                        >
                          <Input.TextArea id="input_contact_2" placeholder="Chúng tôi sẵn sàng lắng nghe ý kiến hỗ trợ của bạn" />
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                          <Button type="primary" id='button_contact' htmlType="submit">
                            <strong>GỬI HỖ TRỢ</strong>
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }
}
const cssstyle = `
.slick-next:before, .slick-prev:before {
    color:#dceee4;
    font-size: 0px;
    line-height: 0.4;
}
`
export default BeexCameraPlatform